<template>
  <div>
    <div v-if="id && title && slug" class="flex justify-center p-4 ">
      <div>
        <div class="bg-yellow-50 rounded-lg text-yellow-800 border border-yellow-300 p-4">
          <div class="flex items-center justify-between">
            <h1 class="font-semibold text-base md:text-lg">
              {{ title }}
            </h1>
            <Icon
              name="mdi:bell-ring"
              class="flex-shrink-0 inline w-4 h-4 md:w-5 md:h-5"
            />
          </div>

          <h2 class="text-sm md:text-base mt-2">
            Join our waiting list to be notified when tickets become available.
          </h2>
        </div>
        <div class="flex flex-col justify-center items-center bg-white rounded-md border mt-4">
          <div v-if="!formSubmitted && !submitting && !errorMessage" class="mt-6 px-4 sm:px-0">
            <FormKit type="form" @submit="submitSignupHandler">
              <FormKitSchema :schema="formSchema" />
            </FormKit>
          </div>
          <div v-if="formSubmitted && !submitting && !errorMessage" class="p-4">
            <p class="font-semibold text-gray-700">
              Thank you for joining the <span class="text-black">{{ title }}</span> waitlist!
            </p>
            <p class="mt-8">
              Feel free to close this page, but remember to check your email regularly so you don't miss out on any ticket updates.
            </p>
          </div>
          <div v-if="submitting" class="py-10 flex items-center gap-3">
            <AnimationSpinner /> Please wait...
          </div>
          <!-- ERROR ALERT -->
          <div v-if="errorMessage && !submitting" class="p-4 w-full">
            <div class="rounded-md bg-red-50 p-4">
              <div class="flex">
                <div class="flex-shrink-0">
                  <Icon name="mdi:alert-circle" class="h-5 w-5 text-red-400" />
                </div>
                <div class="ml-3">
                  <h3 class="text-sm font-medium text-red-800">
                    There was a problem
                    with your submission
                  </h3>
                  <div class="mt-2 text-sm text-red-700">
                    <ul role="list" class="list-disc space-y-1 pl-5">
                      <li>{{ errorMessage }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()
const props = defineProps({
  id: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  slug: {
    type: String,
    required: true
  }
})

const { id, title, slug } = toRefs(props)

const route = useRoute()
const tenantId = route?.params?.tenant

const errorMessage = ref('') // Error message returned from the API

const formSubmitted = ref(false)
const submitting = ref(false)
// Submit subscriber to back-end
const submitSignupHandler = async (formData) => {
  // Clear any previous error
  errorMessage.value = ''
  try {
    // Post the data to the API
    formSubmitted.value = true
    const { data, error } = await useFetch(`${config.public.WETIX_SERVICE_API_BASE_URL}/v1/public/subscribe-to-mailing-list`,
      {
        method: 'POST',
        body: {
          ...formData,
          mailingListId: `waitlist-notify-me_event_${slug.value}`,
          subscriberMeta: {
            subscriptionCreatedByClient: 'wetix-shop/EventWaitlistSignupForm',
            subscriptionCategory: 'waitlist-notify-me', // Indicates the model for arbiatry data passed into the subscriberMeta
            event: {
              id: id.value,
              eventName: title.value,
              tenantId
            }
          }
        }
      }) as any
    if (data.value) {
      console.log('Successfully subscribed', data.value)
      // If the request was successful, close the modal
    }
    // If there is an error, set the error message
    if (error.value) {
      errorMessage.value = error?.value?.data?.message || 'An unknown error occurred'
    }
  } catch (error) {
    console.error(error)
    errorMessage.value = error?.value?.data?.message || 'An unknown error occurred'
  }
  submitting.value = false
}
// Form schema for subscribe form
const formSchema = [

  {
    $formkit: 'text',
    label: 'First Name',
    name: 'firstName',
    // help: 'Enter your first name',
    validation: 'required',
    classes: {
      outer: 'first-outer'
    }
  },
  {
    $formkit: 'text',
    label: 'Last Name',
    name: 'lastName',
    // help: 'Enter your last name',
    validation: 'required',
    classes: {
      outer: 'first-outer'
    }
  },
  {
    $formkit: 'text',
    name: 'email',
    label: 'Email',
    help: 'We will email you when tickets are available.',
    validation: 'required|email'
  },
  {
    $formkit: 'text',
    name: 'mobilePhone',
    label: 'Mobile ',
    // validation: 'matches:((\+44(\s\(0\)\s|\s0\s|\s)?)|0)7\d{3}(\s)?\d{6}$/',
    help: 'We will text you when tickets are available. (optional)'

  },
  {
    $cmp: 'FormKit',
    props: {
      name: 'promoConsent',
      type: 'checkbox',
      id: 'promoConsent',
      validation: 'required',
      label: 'I consent to being contacted when tickets are available.'
    }
  }

]
</script>
